export const num2name = {
    0: "ERROR_UNSPECIFIED",
    1: "ERROR_NOT_FOUND",
};
export const name2num = {
    ERROR_UNSPECIFIED: 0,
    ERROR_NOT_FOUND: 1,
};
